import React from "react";
import { Icon } from "@iconify/react";
import { Input } from "../../ui/input";

const DataTableSearch = ({ table, column }) => {
  return (
    <div>
      <div className="relative">
        <Icon
          className="absolute text-muted-foreground left-2.5 top-1.5 h-5 w-5"
          icon="line-md:search"
        />
        <Input
          placeholder={`Search ${column.replace("_", " ")}...`}
          value={table.getColumn(column)?.getFilterValue() ?? ""}
          onChange={(event) => {
            table.getColumn(column)?.setFilterValue(event.target.value)
            table.setPageIndex(0);
          }}
          className="appearance-none bg-background pl-10 h-8 w-full lg:w-[250px] md:w-2/3"></Input>
      </div>
    </div>
  );
};

export default DataTableSearch;
